import {
    List, Datagrid, TextField, DateField,
    Edit, SimpleForm, TextInput,
    Create, TopToolbar, ListButton,
} from 'react-admin';

export const PermissionList = () => (
    <List>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="category" />
            <TextField source="description" />
            <DateField source="createdAt" />
        </Datagrid>
    </List>
);

export const PermissionEdit = () => (
    <Edit actions={<TopToolbar><ListButton /></TopToolbar>}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="category" />
            <TextInput source="description" multiline />
        </SimpleForm>
    </Edit>
);

export const PermissionCreate = () => (
    <Create actions={<TopToolbar><ListButton /></TopToolbar>}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="category" />
            <TextInput source="description" multiline />
        </SimpleForm>
    </Create>
);
